module.exports = __webpack_public_path__ + "static/media/1080X1080 HOME-PLATILLOS-BEBIDAS_50.2eb34bd0.webp";